import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["upvoteButton", "downvoteButton"]

  static values = { emailTemplateId: Number }

  upvote() {
    this.vote(true)
  }

  downvote() {
    this.vote(false)
  }

  vote(upvote) {
    var _this = this
    $.ajax({
      url: `/templates/${this.emailTemplateIdValue}/votes`,
      type: "POST",
      data: { "upvote": upvote },
      dataType: "json",
      headers: {
        "X-CSRF-Token": $("meta[name='csrf-token']").attr("content"),
      },
      error: function() {
        App.displayFlash("danger", "The vote couldn't be saved.")
      },
      success: function (response) {
        _this.updateButtons(response)
      }
    })
  }

  updateButtons(response) {
    if (response.upvote) {
      this.upvoteButtonTarget.classList.add("selected")
      this.downvoteButtonTarget.classList.remove("selected")
    } else if (response.upvote === false) {
      this.upvoteButtonTarget.classList.remove("selected")
      this.downvoteButtonTarget.classList.add("selected")
    } else {
      this.upvoteButtonTarget.classList.remove("selected")
      this.downvoteButtonTarget.classList.remove("selected")
    }

    this.upvoteButtonTarget.getElementsByTagName("STRONG")[0].innerHTML = response.upvotes_count
  }
}
